import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { SkuInfoQuery, SkuInfoVo } from './type';

/**
 * 上传数字商品offer时，输入skuName查询数据
  GET /product/offerManage/getDigitalProductSku
  接口ID：252301367
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-252301367
 */
export const getSkuInfoList = (params: SkuInfoQuery): AxiosPromise<SkuInfoVo[]> => {
  return request({
    url: '/product/offerManage/getDigitalProductSku',
    method: 'get',
    params
  });
};
